<template>
  <div class="wrapper">
    <section id="login">
      <div class="container-fluid">
        <div class="row full-height-vh">
          <div class="col-12 d-flex align-items-center justify-content-center gradient-aqua-marine">
            <div class="card px-4 py-2 box-shadow-2 width-600">
              <div class="card-header text-center">
                <h1>{{ $t("labels.changePassword") }}</h1>
              </div>
              <div class="card-body">
                <div class="card-block">
                  <form @submit.prevent="setNewPassword" v-if="tokenValid">
                    <div class="form-group">
                      <div class="col-md-12">
                        <input
                          type="password"
                          class="form-control form-control-lg"
                          name="inputPassword"
                          id="inputPassword"
                          v-model="password"
                          :placeholder='$t("labels.newPassword")'
                          required
                        >
                      </div>
                    </div>
                    <div class="form-group">
                         <div class="col-md-12">
                        <input
                          type="password"
                          class="form-control form-control-lg"
                          name="inputPasswordConfirmation"
                          id="inputPasswordConfirmation"
                          v-model="passwordConfirmation"
                          :placeholder='$t("labels.passwordConfirmation")'
                          required
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="text-center col-md-12">
                        <button
                          type="submit"
                          class="btn btn-danger px-4 py-2 text-uppercase white font-small-4 box-shadow-2 border-0"
                        >{{ $t("labels.submit") }}</button>
                      </div>
                    </div>
                  </form>
                  <div v-if="tokenValid.length == 0">
                      <h2>{{ $t("labels.tokenCheck") }}</h2>
                  </div>
                  <div v-if="!tokenValid">
                      <h5 class="text-center">{{ $t("labels.invalidToken") }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AuthService from "../../services/auth";

export default {
  name: "LoginPage",
  metaInfo: {
    title: "Dravet Diary Admin", // set a title
    titleTemplate: "%s" // title is now "My Example App - Yay!",
  },
  
  data: function() {
    return {
      tokenValid: false,
      errors: [],
      password: '',
      passwordConfirmation: ''
    };
  },
  computed: {
    passwordResetToken(){
        return this.$route.params.token
    }
  },
  methods: {
    setNewPassword: async function() {
        if (this.tokenValid) {
            if (this.password.length < 8) {
                this.errors.push(this.$t("errors.passwordLength", ["8"]))
            }
            if (this.password != this.passwordConfirmation) {
                this.errors.push(this.$t("errors.passwordMatch"))
            }

            if (this.errors.length == 0) {
                let result = await AuthService.setNewPassword(this.password,this.passwordConfirmation,this.passwordResetToken)
                if (result.data.success == true) {
                    this.$miniToastr.success(result.data.msg)
                    this.$router.push({ name: "login" })
                } else {
                    this.$miniToastr.error(result.data.msg)
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                this.errors = []
                this.password = ''
                this.passwordConfirmation = ''
            }
        }
    }
  },
  mounted: async function() {
    let tokenCheck = await AuthService.checkPasswordToken(this.passwordResetToken)
    if (tokenCheck.data.success == true) {
        this.tokenValid = true
    } else {
        this.tokenValid = false
    }
  }
};
</script>
